import AccountListForm from "./AccountListForm";
import ActivityFormQuestionForm from "./ActivityFormQuestionForm";
import ActivityCertificateForm from "./ActivityCertificateForm";
import ActivityQuestionform from "./ActivityQuestionform";
import BookingBosendorferStep1Form from "./BookingBosendorferStep1Form";
import BookingBosendorferStep2Form from "./BookingBosendorferStep2Form";
import BookingStep1Form from "./BookingStep1Form";
import BookingStep2Form from "./BookingStep2Form";
import EmailForm from "./EmailForm";
import FirstnameForm from "./FirstnameForm";
import ForgetPassword from "./ForgetPassword";
import ForgetPasswordForm from "./ForgetPasswordForm";
import ForgetPasswordStep2 from "./ForgetPasswordStep2";
import ForgetPasswordStep3 from "./ForgetPasswordStep3";
import InterestedForm from "./InterestedForm";
import LastnameForm from "./LastnameForm";
import LoginForm from "./LoginForm";
import LoginStep1Form from "./LoginStep1Form";
import LoginStep2Form from "./LoginStep2Form";
import MusicHallRegisBookingForm from "./MusicHallRegisBookingForm";
import MusicHallRegisContactInfoForm from "./MusicHallRegisContactInfoForm";
import MusicHallRegisEquipmentAdditionalForm from "./MusicHallRegisEquipmentAdditionalForm";
import MusicHallRegisEquipmentProviderForm from "./MusicHallRegisEquipmentProviderForm";
import MusicHallRegisEventForm from "./MusicHallRegisEventForm";
import MusicHallRegisNumberGuestForm from "./MusicHallRegisNumberGuestForm";
import MusicHallRegisTermConditionForm from "./MusicHallRegisTermConditionForm";
import MusicPracticeRoomSelectDateForm from "./MusicPracticeRoomSelectDateForm";
import MusicPracticeRoomSelectRoomForm from "./MusicPracticeRoomSelectRoomForm";
import OnlineFormRequestEditForm from "./OnlineFormRequestEditForm";
import OrganizationEditForm from "./OrganizationEditForm";
import PDPAForm from "./PDPAForm";
import PersonalInfoForm from "./PersonalInfoForm";
import PersonalInfoNoMemberForm from "./PersonalInfoNoMemberForm";
import PhoneForm from "./PhoneForm";
import PhoneNumberForm from "./PhoneNumberForm";
import ProductWarranteeForm from "./ProductWarranteeForm";
import ProductWarranteeCoperateNoLoginForm from "./ProductWarranteeCoperateNoLoginForm";
import ProductWarranteeNoLoginForm from "./ProductWarranteeNoLoginForm";
import ProfileForm from "./ProfileForm";
import ProvinceForm from "./ProvinceForm";
import QuickTestActivityForm from "./QuickTestActivityForm";
import QuickTestForm from "./QuickTestForm";
import RegisterCorperateForm from "./RegisterCorperateForm";
import RegisterCorperateOnlyForm from "./RegisterCorperateOnlyForm";
import RegisterForm from "./RegisterForm";
import ScanQRCodeForm from "./ScanQRCodeForm";
import SetPasswordForm from "./SetPasswordForm";
import ShippingForm from "./ShippingForm";
import Step1PhoneRegisForm from "./Step1PhoneRegisForm";
import Step2PhoneRegisForm from "./Step2PhoneRegisForm";
import UploadSlipForm from "./UploadSlipForm";
import VerifyOTPForm from "./VerifyOTPForm";
import VisitorFollowerForm from "./VisitorFollowerForm";
import AddInstrumentForm from "./AddInstrumentForm";

const EXPORT = {
  AccountListForm,
  ActivityCertificateForm,
  ActivityFormQuestionForm,
  ActivityQuestionform,
  AddInstrumentForm,
  BookingBosendorferStep1Form,
  BookingBosendorferStep2Form,
  BookingStep1Form,
  BookingStep2Form,
  EmailForm,
  FirstnameForm,
  ForgetPassword,
  ForgetPasswordForm,
  ForgetPasswordStep2,
  ForgetPasswordStep3,
  InterestedForm,
  LastnameForm,
  LoginForm,
  LoginStep1Form,
  LoginStep2Form,
  MusicHallRegisBookingForm,
  MusicHallRegisContactInfoForm,
  MusicHallRegisEquipmentAdditionalForm,
  MusicHallRegisEquipmentProviderForm,
  MusicHallRegisEventForm,
  MusicHallRegisNumberGuestForm,
  MusicHallRegisTermConditionForm,
  MusicPracticeRoomSelectDateForm,
  MusicPracticeRoomSelectRoomForm,
  OnlineFormRequestEditForm,
  OrganizationEditForm,
  PDPAForm,
  PersonalInfoForm,
  PersonalInfoNoMemberForm,
  PhoneForm,
  PhoneNumberForm,
  ProductWarranteeCoperateNoLoginForm,
  ProductWarranteeForm,
  ProductWarranteeNoLoginForm,
  ProfileForm,
  ProvinceForm,
  QuickTestActivityForm,
  QuickTestForm,
  RegisterCorperateForm,
  RegisterCorperateOnlyForm,
  RegisterForm,
  ScanQRCodeForm,
  SetPasswordForm,
  ShippingForm,
  Step1PhoneRegisForm,
  Step2PhoneRegisForm,
  UploadSlipForm,
  VerifyOTPForm,
  VisitorFollowerForm,
};

export default EXPORT;
